<script setup lang="ts">
import { useSidebarPrivileges } from '@entities/viewer'

import UserAvailability from './UserAvailability.vue'
import UserMenu from './UserMenu.vue'

defineOptions({
  name: 'UserPanel',
})

const { canManageAvailability } = useSidebarPrivileges()
</script>

<template>
  <div :class="['user-panel', { availability: canManageAvailability }]">
    <UserAvailability v-if="canManageAvailability" />
    <UserMenu />
  </div>
</template>

<style scoped lang="scss" src="./UserPanel.scss" />
